import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { createProduct, getToken, uploadFile } from './api';
import ProductForm from './ProductForm';
import { AdminImagePreview, emptyProduct } from './adminUi';

export default function ProductNew() {
  const navigate = useNavigate();
  const [product, setProduct] = useState(() => emptyProduct());
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!getToken()) {
      navigate('/admin', { replace: true });
    }
  }, [navigate]);

  async function onUpload(file) {
    if (!file) return;
    try {
      const { url } = await uploadFile(file);
      setProduct((p) => ({ ...p, image: url }));
    } catch (e) {
      setErr(e.message || 'Upload failed');
    }
  }

  async function handleSave(e) {
    e.preventDefault();
    setErr('');
    setSaving(true);
    try {
      await createProduct(product);
      navigate('/admin/dashboard/products');
    } catch (e) {
      setErr(e.message || 'Save failed');
    } finally {
      setSaving(false);
    }
  }

  return (
    <>
      <header className="z-10 flex shrink-0 flex-wrap items-center justify-between gap-3 border-b border-neutral-200 bg-white px-4 py-3 md:px-8">
        <div>
          <Link
            to="/admin/dashboard/products"
            className="text-xs font-medium text-brand-olive hover:underline"
          >
            ← Back to products
          </Link>
          <h2 className="mt-1 text-lg font-bold text-neutral-900 md:text-xl">New product</h2>
        </div>
      </header>

      <main className="min-h-0 w-full min-w-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-y-contain px-4 py-6 md:px-8 md:py-8">
        {err ? <p className="mb-4 text-sm text-red-600">{err}</p> : null}

        <form onSubmit={handleSave} className="w-full max-w-none rounded-2xl border border-neutral-200 bg-white p-6 shadow-sm">
          <AdminImagePreview src={product.image} alt={product.alt} emptyLabel="Preview" />

          <ProductForm product={product} onChange={setProduct} onUploadImage={onUpload} />

          <div className="mt-8 flex flex-wrap gap-3">
            <button
              type="submit"
              disabled={saving}
              className="rounded-lg bg-brand-forest px-5 py-2.5 text-sm font-semibold text-white hover:opacity-90 disabled:opacity-50"
            >
              {saving ? 'Saving…' : 'Save product'}
            </button>
            <Link
              to="/admin/dashboard/products"
              className="rounded-lg border border-neutral-300 bg-white px-5 py-2.5 text-sm font-medium text-neutral-700 hover:bg-neutral-50"
            >
              Cancel
            </Link>
          </div>
        </form>
      </main>
    </>
  );
}
